export default __webpack_public_path__ + "static/media/Arrow.3f3fbf89.svg";